<template>
    <div>
        <common-table :url="url" :table-columns="tableColumns" :form-fields="formFields" :operate="operate" :permission="permission" :searchs="searchs"></common-table>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";

    export default {
        name: "Ordergrab",
        components: {CommonTable},
        data(){
            return{
                searchs:[
                    {
                        name: 'orderName',
                        placeholder: '订单名称',
                        type: 'input'
                    },
                    {
                        name: 'orderNo',
                        placeholder: '订单号',
                        type: 'input'
                    },
                    {
                        name: 'username',
                        placeholder: '用户名',
                        type: 'input'
                    },
                    {
                        name: 'money',
                        placeholder: '订单金额',
                        type: 'input'
                    },
                    {
                        name: 'status',
                        placeholder: '订单状态',
                        type: 'select',
                        selectValue:[{
                            key: 0,
                            value: '用户取消'
                        },{
                            key: 1,
                            value: '成功'
                        },{
                            key: 2,
                            value: '超时取消'
                        },{
                            key: 3,
                            value: '冲正'
                        }]
                    },
                    {
                        name: 'startTime',
                        placeholder: '开始时间',
                        type: 'dateTime'
                    },
                    {
                        name: 'endTime',
                        placeholder: '结束时间',
                        type: 'dateTime'
                    }
                ],
                permission:{
                    add: 'ordergrab:add',
                    update: 'ordergrab:update',
                    delete: 'ordergrab:delete',
                    deleteBatch: 'ordergrab:deleteBatch'
                },
                url: {
                    get: '/ordergrab/listByCondition',
                    //add: '/ordergrab/add',
                    //update: '/ordergrab/update',
                    //delete: '/ordergrab/delete/',
                    //delete_batch: '/ordergrab/deleteBatch',
                },
                tableColumns: [{
                    field: 'orderId',
                    label: '订单ID',
                    show: true,
                    width: '',
                },{
                    field: 'orderName',
                    label: '订单名称',
                    show: true,
                    width: '',
                },{
                    field: 'orderNo',
                    label: '订单号',
                    show: true,
                    width: '',
                },{
                    field: 'money',
                    label: '订单金额',
                    show: {
                        type: 'money'
                    },
                    width: '',
                },{
                    field: 'earnings',
                    label: '订单收益',
                    show: {
                        type: 'money'
                    },
                    width: '',
                },{
                    field: 'userNick',
                    label: '用户昵称',
                    show: true,
                    width: '',
                },{
                    field: 'commission',
                    label: '平台抽佣',
                    show: {
                        type: 'money'
                    },
                    width: '',
                },{
                    field: 'status',
                    label: '状态',
                    show: {
                        type: 'tag',
                        tags: [{
                            key: 0,
                            value: '用户取消',
                            type: 'info'
                        },{
                            key: 1,
                            value: '成功',
                            type: 'success'
                        },{
                            key: 2,
                            value: '超时取消',
                            type: 'warning'
                        },{
                            key: 3,
                            value: '冲正',
                            type: 'danger'
                        }]
                    },
                    width: '',
                },{
                    field: 'failCause',
                    label: '失败原因',
                    show: true,
                    width: '',
                },{
                    field: 'grabTime',
                    label: '抢单时间',
                    show: true,
                    width: '',
                },{
                    field: 'completeTime',
                    label: '完成时间',
                    show: true,
                    width: '',
                }/*,{
                    field: 'updateNick',
                    label: '操作人',
                    show: true,
                    width: '',
                }*/],
                formFields: {
                    addTitle: '添加订单',
                    updateTitle: '修改订单',
                    model: [{

                    }],
                },
                operate: [],
            }
        }
    }
</script>

<style scoped>

</style>
